import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { useState } from "react";
import { MenuItem, Select } from "@mui/material";
import { LabelWithControl } from "components/common/LabelControl";
import { useSelector } from "react-redux";
import { PAGE, PO_REASON } from "./CONSTANTS";

export const SelectReasonDialog = ({
  reasonType,
  title,
  message,
  selectReasonDialog,
  onReasonDialogClose,
  handleConfirmReason,
}) => {
  const { reasonCodesResponse } = useSelector((state) => state.reasonCodes);
  const reasonCodes = reasonCodesResponse?.reasonCodes?.filter(
    (item) =>
      item.orderType === PO_REASON.ORDER_TYPE &&
      item.orderSubtype === reasonType
  );
  const [selectedReason, setSelectedReason] = useState("");
  const currentUrl = window.location?.pathname;
  const handleReasonChange = (event) => {
    setSelectedReason(event.target.value);
  };

  const onCancelClick = () => {
    onReasonDialogClose();
    setSelectedReason("");
  };

  const onConfirmClick = () => {
    handleConfirmReason(selectedReason);
    setSelectedReason("");
  };

  return (
    <Dialog open={selectReasonDialog}>
      <div className="dialogStyling">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText className="dialogContentMargin">
            {message}
          </DialogContentText>
          <div className="labelControl">
            <LabelWithControl label="Reason">
              <Select
                name="reason"
                labelId="reason"
                id="reason"
                value={selectedReason}
                placeholder="Select reason"
                onChange={handleReasonChange}
                className="dropDownValue"
                fullWidth
                displayEmpty
                size="small"
                style={{ marginBottom: "10px" }}
              >
                <MenuItem value="" disabled>
                  Select Reason
                </MenuItem>
                {reasonCodes?.map((element) => (
                  <MenuItem
                    key={element.reasonCodeId}
                    value={element.reasonCode}
                  >
                    {element.description}
                  </MenuItem>
                ))}
              </Select>
            </LabelWithControl>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="parentPoButtons">
            {currentUrl !== PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.url &&
              currentUrl !== PAGE.UPLOAD_MANUAL_PO_ERROR.url && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onCancelClick}
                  className="commonPOButtons"
                  style={{
                    marginRight: "8px",
                  }}
                >
                  Back
                </Button>
              )}
            <Button
              variant="contained"
              color="primary"
              disabled={!(selectedReason && selectedReason > 0)}
              onClick={onConfirmClick}
              className="commonPOButtons"
            >
              Confirm
            </Button>
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
};
